export default __webpack_public_path__ + "static/media/sizeguide.0dc6b96f.jpg";